export const isEmpty = (str) => (str?.trim() === "" ? true : false);
